// 전체화면 창·side panel 시스템의 z 단계다. c6 오버레이 밴드 사이에 넣는다. 이 파일이 SoT 이고,
// 소비처는 inline style 로 지정한다. inline 을 쓰는 이유가 있다. c6 modalStack 의 inert 판정
// (effectiveZ)은 body 직속 자식의 computed z-index 를 읽는다. 그래서 시각 z 와 판정 z 가 같은 값에서
// 나와야 한다. CSS 파일에 값을 한 번 더 두면 두 값이 어긋난다.
//
//   창 오버레이(880) < 작업표시줄(890) < side panel(892, 전 패널 공유)
//     < c6 tooltip 밴드(900) < c6 Modal 밴드(1000~)
//
// - 창(880): 창 스택이 그리는 전체화면 창이다. c6 Modal 밴드보다 낮으므로 중첩 c6 Modal(컴포저·
//   ConfirmModal)이 위에 쌓인다. tooltip 밴드보다 낮으므로 호버 툴팁이 오버레이 위에 표시된다.
// - 작업표시줄(890): 활성 **창** 위에서 항상 조작할 수 있어야 한다(창 전환·최소화·닫기). 창이
//   modalStack 에 등록돼도 z 가 더 높은 body 직속 비-Modal 오버레이는 inert 대상에서 빠진다.
// - side panel(892): 창 스택 밖의 우측 도킹 패널(RightSidePanel)이다. 작업표시줄 **위**에 둔다.
//   열려 있는 동안 modalStack 이 작업표시줄도 inert 로 잠근다. 그래서 페이지·스택 창·작업표시줄이
//   모두 패널 아래에 놓인다(패널이 최상단이라는 제품 결정). 패널 위 패널(예: 비교 위의 run 상세)은
//   별도 z 없이 등록 순서로 겹침을 정한다. modalStack 동률 규칙(나중 등록이 topmost)과 DOM 순서를 쓴다.
export const FULLSCREEN_WINDOW_Z = 880;
export const WINDOW_TASKBAR_Z = 890;
export const RIGHT_SIDE_PANEL_Z = 892;
